import { ImaAppType } from '@tt4b/ttam-enums';
import whatsAppIcon from '@tt4b/ttam-assets/src/svgs/creative/whatsapp.svg?url';
import messengerIcon from '@tt4b/ttam-assets/src/svgs/creative/messenger.svg?url';

export function usePropsImaAppList() {
  const ImaAppList = [
    {
      label: 'Messenger',
      value: ImaAppType.MESSENGER,
      src: messengerIcon,
    },
    {
      label: 'WhatsApp',
      value: ImaAppType.WHATSAPP,
      src: whatsAppIcon,
    },
  ];
  return {
    ImaAppList,
  };
}
